<template>
  <base-dynamic-key
    :code="code"
    :url="url"
    @backToLesson="$emit('backToLesson')"
    @stopRegistration="$emit('stopRegistration')"
  >
    <template slot="explanation">
      {{ trans('key.single_key_explanation') }}
    </template>

    <template slot="key-extra">
      <p>{{ trans('pptQR.qr_code') }} {{ index }}</p>
    </template>
  </base-dynamic-key>
</template>

<script>
import BaseDynamicKey from '@/employees/DynamicKey/BaseDynamicKey'

export default {
  name: 'BaseSingleKeyRp',

  components: { BaseDynamicKey },

  props: {
    url: {
      required: true,
      type: String,
    },
    index: {
      required: true,
      type: Number,
    },
    code: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      openModal: false,
    }
  },
}
</script>

<style scoped>
</style>
